// extracted by mini-css-extract-plugin
export default {"sib-help-btn":"WbGoj15RbAifZ9jDoHhP","sib-btn":"syb5MEqRpIhpuCvOKti5","sib-btn_icon-stand-alone":"IyUZ1VPu_EVD_Pn_2ArV","sib-help-btn__active":"FhIelQG_5s4rXqsyHwCg"};